import { PageController } from '@client/components/_core/layout/PageController';
import { EmailMessageForm } from '@client/components/claims/new-message/EmailMessageForm';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { Modal } from 'antd';
import { useState } from 'react';
import { claimFormStore } from '../../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/comms/add/email')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Send email',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <EmailCommLogAdd />
        </PageController>
    );
}

function EmailCommLogAdd() {
    const claim = claimFormStore.use.formData();
    const { trpcUtils } = useTrpc();
    const navigate = useNavigate();

    const [open, setOpen] = useState(true);

    const handleClose = () => setOpen(false);

    const handleAfterClose = () => {
        void trpcUtils.communication.listCommLogAndNotes.invalidate({ claimId: claim.id });
        void trpcUtils.claim.getClaimClientUpdateSummary.invalidate({ id: claim.id });
        navigate({ moveInMatches: -1 });
    };

    return (
        <Modal
            open={open}
            width={900}
            footer={false}
            title="Send email"
            onCancel={handleClose}
            afterClose={handleAfterClose}
            destroyOnHidden
            centered
            styles={{
                body: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', scrollbarGutter: 'stable' },
            }}
            classNames={{ body: 'pt-2 pr-3 [scrollbar-width:thin]' }}
        >
            <EmailMessageForm claimId={claim.id} onClose={handleClose} />
        </Modal>
    );
}
